import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "../../../../../services/UI/State/State";
import { ICalendarState } from "../../ICalendarState";

export function GetCompletedCalendarEventIds() {
    const calendar = State.ReadClass<ICalendarState>(ESharedComponent.Calendar);

    if (!calendar || !calendar.state || !calendar.state.eventData) {
        return [];
    }

    const eventIds = calendar.state.eventData
        .filter((event) => event.isCompleted)
        .map((event) => event.completionEventId);

    return eventIds;
}
